





























import { Component, Vue, Prop } from "vue-property-decorator";
import BigPic from "./BigPic.vue";
import ManyPic from "./ManyPic.vue";
import NoPic from "./NoPic.vue";
import ThinPic from "./ThinPic.vue";
import SinglePic from "./SinglePic.vue";
import { INews } from "@/api/types";
@Component({
  components: {
    "no-pic": NoPic,
    "single-pic": SinglePic,
    "big-pic": BigPic,
    "thin-pic": ThinPic,
    "many-pic": ManyPic
  }
})
export default class Index extends Vue {
  @Prop()
  item: INews | undefined;

  itemClickIndex(data: INews) {
    this.$emit("itemClick", data);
  }
}
